module.exports = __webpack_public_path__ + "img/14@2x.aee7ab14.png";